import React, { useCallback } from 'react';
import { NestedCheckbox, NestedCheckboxData } from '../../../../NestedCheckbox';
import { IncentiveOption } from '../../../../../@types/Marketing';
import { toCheckboxData, toIncentiveData } from '../../../../../utils/marketingUtils';

interface Props {
  isDisabled?: boolean;
  incentiveData: IncentiveOption[];
  onChange: (data: IncentiveOption[]) => void;
}

export function IncentiveCheckboxes({ isDisabled = false, incentiveData, onChange }: Props): JSX.Element {
  const checkboxData: NestedCheckboxData = toCheckboxData(incentiveData);

  const handleChange = useCallback(
    (data: NestedCheckboxData) => {
      const incentive = toIncentiveData(data);
      onChange(incentive);
    },
    [onChange]
  );

  return (
    <NestedCheckbox
      className="border-1 border-gray-default rounded-xl p-3"
      checked={checkboxData.checked}
      label={checkboxData.label}
      isDisabled={isDisabled}
      children={checkboxData.children}
      onChange={handleChange}
    />
  );
}
